import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  CircularProgress,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import { FaCheck, FaTimes } from "react-icons/fa";
import "../AgentWithdrawlRequests/AgentWithdrawlRequests.css";
import { axiosInstance } from "../../axiosInstance";
import { toast } from "react-toastify";
import { GoSearch } from "react-icons/go";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { GoDownload } from "react-icons/go";
import { FiSend } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// Table columns
const columns = [
  { id: "withdraw_id", label: "WITHDRAW ID", minWidth: 120, align: "center" },
  { id: "user_name", label: "USER NAME", minWidth: 150, align: "center" },
  {
    id: "amount_to_withdraw",
    label: "WITHDRAW AMOUNT",
    minWidth: 150,
    align: "center",
  },
  {
    id: "available_balance",
    label: "AVAILABLE AMOUNT",
    minWidth: 150,
    align: "center",
  },
  {
    id: "created_at",
    label: "REQUESTED DATE",
    minWidth: 150,
    align: "center",
  },
  {
    id: "payment_status",
    label: "PAYMENT STATUS",
    minWidth: 150,
    align: "center",
  },
  {
    id: "updated_at",
    label: "APPROVED DATE",
    minWidth: 150,
    align: "center",
  },
  //   { id: "actions", label: "ACTIONS", minWidth: 150, align: "center" },
];

const formatDate = (dateString) => {
  if (!dateString) return "--";
  const date = new Date(dateString);
  if (isNaN(date)) return "--";
  return date.toLocaleDateString("en-GB");
};

export function WithdrawRequest() {
  const [page, setPage] = useState(0);
  const [error, setError] = useState("");
  const [withdrawList, setWithdrawList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);

  // file upload modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [searchQuery, setSearchQuery] = useState("");
  const [activeEdit, setactiveEdit] = useState("pending");

  const fetchAgentWithdrawlRequests = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/user-withdraw-list/");
      if (res.data.status === "success") {
        setWithdrawList(res.data.data.results || []);
      } else {
        setError("Failed to fetch withdraw requests.");
      }
    } catch (err) {
      console.error("Error fetching withdraw requests:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgentWithdrawlRequests();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Search by agent name OR approved date (updated_at)
  const filteredData = withdrawList.filter((row) => {
    const userId = `${row.user_id || ""}`.toLowerCase();
    const approvedDate = formatDate(row.updated_at).toLowerCase();
    return (
      userId.includes(searchQuery.toLowerCase()) ||
      approvedDate.includes(searchQuery.toLowerCase())
    );
  });

  const pendingData = filteredData.filter(
    (row) => row.payment_status?.toLowerCase() === "pending",
  );

  const completedData = filteredData.filter(
    (row) => row.payment_status?.toLowerCase() === "success",
  );

  // date filter

  const [filterDate, setFilterDate] = useState(null);

  const applyDateFilters = async (selectedDate) => {
    if (!selectedDate) return; // no date selected

    setLoading(true);
    setError("");
    try {
      //   const body = {
      //     date: dayjs(selectedDate).format("DD-MM-YYYY"), // use the Dayjs object directly
      //   };
      const config = {
        params: {
          date: dayjs(selectedDate).format("DD-MM-YYYY"),
        },
      };

      const res = await axiosInstance.get("/admin/user-withdraw-list/", config);
      if (res.data.status === "success") {
        setWithdrawList(res.data.data.results || []);
      } else {
        setError("Filter failed.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
      setPage(0);
    }
  };

  const clearDateFilters = () => {
    //clear date filters
    setFilterDate(null);
    fetchAgentWithdrawlRequests();
  };

  const [file, setFile] = useState(null);
  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]); // store selected file
  // };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = [
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed");
      e.target.value = null; // reset input
      return;
    }

    setFile(selectedFile);
  };

  // const handleClearFile = () => {
  //   setFile(null);
  //   document.getElementById("bulkUpload").value = ""; // reset input

  // };
  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoader(true);
      const response = await axiosInstance.post(
        "/admin/withdraw-upload-api/",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data.message || "Uploaded successfully!");
        fetchAgentWithdrawlRequests();
        setFile(null); // reset after upload
        handleClose();
      }
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error(err.response.data.message || "Upload failed!");
    } finally {
      setLoader(false);
    }
  };
  async function handleDownload() {
    try {
      setLoader(true);
      const payload = {
        //  date: dayjs(filterDate).format("DD-MM-YYYY"),
        date: dayjs(filterDate).format("YYYY-MM-DD"),
      };

      const response = await axiosInstance.post(
        `/admin/withdraw-download-api/`,
        payload,
        {
          responseType: "blob", // required
        },
      );

      if (response.status === 200) {
        // const blob = new Blob([response.data], { type: "application/pdf" });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        // const contentDisposition = response.headers["content-disposition"];
        // let fileName = "invoice.pdf";
        // // let fileName;
        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?(.+)"?/);
        //   if (match && match[1]) fileName = match[1];
        // }

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "withdraw-report.xlsx";

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            fileName = match[1].endsWith(".xlsx")
              ? match[1]
              : `${match[1]}.xlsx`;
          }
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      // toast.error(error?.response?.data?.message || "Unable to download");

      // console.error("Download error:", error);
      let errorMessage = "Unable to download";

      if (error.response && error.response.data) {
        const data = error.response.data;

        if (data instanceof Blob) {
          // If backend sent JSON in blob (common for errors)
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const json = JSON.parse(reader.result);
              toast.error(json.message || errorMessage);
            } catch {
              toast.error(errorMessage);
            }
          };
          reader.readAsText(data);
        } else if (data.message) {
          toast.error(data.message);
        } else {
          toast.error(errorMessage);
        }
      } else {
        toast.error(errorMessage);
      }

      console.error("Download error:", error);
    } finally {
      setLoader(false);
    }
  }
  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "#1265c5" }} />
          </Stack>
        </div>
      )}
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">Withdraw Requests</div>
          {/* <div>
          <select
            className="listAdmin-showRecords"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <option value={20}>Show No of Records</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
            <option value={2000}>2000</option>
            <option value={5000}>5000</option>
          </select>
        </div> */}
          <div className="search-container">
            <div className="nav-search">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ border: "none", outline: "none", marginLeft: "6px" }}
              />
            </div>
          </div>

          <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Date"
                value={filterDate}
                format="DD-MM-YYYY"
                maxDate={dayjs()}
                onChange={(newValue) => {
                  setFilterDate(newValue);
                  applyDateFilters(newValue);
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      "& .MuiOutlinedInput-root": {
                        height: 35,
                        width: 180,
                        "& fieldset": {
                          border: "1px solid #b8b9b9", // custom border
                        },
                        "&:hover fieldset": {
                          border: "1px solid #b8b9b9", // hover border
                        },
                        "&.Mui-focused fieldset": {
                          border: "1px solid #b8b9b9", // focus border
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "black", // label color
                        fontSize: "0.85rem",
                      },
                      "& .MuiInputBase-input": {
                        padding: "4px 8px", // adjust padding
                        fontSize: "0.85rem",
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </div>
          {/* <div className="d-flex gap-1">
          <div className="upload-btn">
            <input
              type="file"
              accept=".xlsx" // allow only .xlsx
              id="bulkUpload"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <label htmlFor="bulkUpload" className="bulkuploadLabel">
              {file ? file.name : "ICICI Payments"}
            </label>
          </div>

          <div>
            {file && (
              <button className="sendBtn" onClick={handleUpload}>
                Send
              </button>
           
            )}
          </div>
        </div> */}
          <div>
            <button className="upload-btn" onClick={handleShow}>
              ICICI Payments
            </button>
          </div>
        </div>
        {filterDate && (
          <div className="d-flex justify-content-between">
            <div>
              <button className="reset-btn" onClick={clearDateFilters}>
                Reset
              </button>
            </div>
            {activeEdit === "pending" && (
              <div>
                <button className="download-btn" onClick={handleDownload}>
                  <span className="me-1 fw-bold">
                    <GoDownload />
                  </span>
                  Download
                </button>
              </div>
            )}
          </div>
        )}
        {/* Tabs  */}
        <div className="wholesalerMenu mb-3">
          <div
            onClick={() => {
              setactiveEdit("pending");
            }}
            className={`edit-menu ${
              activeEdit === "pending" ? "activeEdit" : ""
            }`}
          >
            Pending
          </div>
          <div
            onClick={() => {
              setactiveEdit("completed");
            }}
            className={`edit-menu ${
              activeEdit === "completed" ? "activeEdit" : ""
            }`}
          >
            Completed
          </div>
        </div>
        {activeEdit === "pending" && (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : pendingData.length > 0 ? (
                    pendingData
                      //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.withdraw_id}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#F9FAFB" : "white",
                          }}
                        >
                          <TableCell align="center">
                            {row.withdraw_id}
                          </TableCell>
                          <TableCell align="center">
                            {row.user_id ?? "-"}
                          </TableCell>

                          <TableCell align="center">
                            {row.amount_to_withdraw}
                          </TableCell>
                          <TableCell align="center">
                            {row.available_amount}
                          </TableCell>
                          <TableCell align="center">
                            {formatDate(row.created_at)}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={`status-text ${row.payment_status.toLowerCase()}`}
                          >
                            {row.payment_status}
                          </TableCell>
                          <TableCell align="center">
                            {formatDate(row.updated_at)}
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100]}
              component="div"
              count={pendingData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
        {activeEdit === "completed" && (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : completedData.length > 0 ? (
                    completedData
                      //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.withdraw_id}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#F9FAFB" : "white",
                          }}
                        >
                          <TableCell align="center">
                            {row.withdraw_id}
                          </TableCell>
                          <TableCell align="center">
                            {row.user_id ?? "-"}
                          </TableCell>

                          <TableCell align="center">
                            {row.amount_to_withdraw}
                          </TableCell>
                          <TableCell align="center">
                            {row.available_amount}
                          </TableCell>
                          <TableCell align="center">
                            {formatDate(row.created_at)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ color: "green" }}
                            className={`status-text ${row.payment_status.toLowerCase()}`}
                          >
                            {row.payment_status}
                          </TableCell>
                          <TableCell align="center">
                            {formatDate(row.updated_at)}
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100]}
              component="div"
              count={completedData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
        {/* file upload modal  */}
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="fileUploadModal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              type="file"
              onChange={handleFileChange}
              accept=".xls,.xlsx"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button className="btnFileModalCancel" onClick={handleClose}>
              Cancel
            </Button>
            <Button onClick={handleUpload}>Confirm Upload</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
